import { Expose, Type } from "class-transformer";
import { StockRecordDto } from "./stock-record.dto";
import { BulkDeductErrorDto } from "./bulk-deduct-error.dto";

export class BulkDeductStockRecordResultDto {
  @Expose()
  @Type(() => StockRecordDto)
  success: StockRecordDto[];

  @Expose()
  @Type(() => BulkDeductErrorDto)
  errors: BulkDeductErrorDto[];
}
